import React, { createContext, useState, useCallback, useEffect, useMemo } from 'react';
import { getStaffProfile } from '../api/endpoints/auth';
import { getAllowedPaths, isPathAllowed } from '../config/accessControl';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('staffToken'));
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const allowedPaths = useMemo(() => getAllowedPaths(user), [user]);

  const hasPathAccess = useCallback((path) => {
    return isPathAllowed(path, allowedPaths);
  }, [allowedPaths]);

  const hasPermission = useCallback(() => true, []);

  useEffect(() => {
    const loadUser = async () => {
      const storedToken = localStorage.getItem('staffToken');
      if (storedToken) {
        try {
          const { data } = await getStaffProfile();
          setUser(data.data);
          setIsAuthenticated(true);
        } catch {
          localStorage.removeItem('staffToken');
          localStorage.removeItem('staffUser');
          setToken(null);
          setUser(null);
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };
    loadUser();
  }, []);

  const login = useCallback((token, userData) => {
    localStorage.setItem('staffToken', token);
    localStorage.setItem('staffUser', JSON.stringify(userData));
    setToken(token);
    setUser(userData);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('staffToken');
    localStorage.removeItem('staffUser');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      token,
      login,
      logout,
      isAuthenticated,
      loading,
      allowedPaths,
      hasPathAccess,
      hasPermission,
      role: user?.role,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
